import { EditorialProductRecommendation } from "../../../contents/productRecommendations/types"
import { Product } from "../../../types/product"
import { toAlgoliaFilter } from "../api/filters"
import { toProduct } from "../converters"
import { getAlgoliaClient, PRODUCTS_INDEX_NAME } from "../services/client"
import { AlgoliaProductVariant } from "../types/doc"

export interface FetchAlgoliaRecommendationItemsInput {
  items: EditorialProductRecommendation[]
  userToken?: string
}

export const fetchAlgoliaRecommendationItems = async (
  input: FetchAlgoliaRecommendationItemsInput
): Promise<Product[]> => {
  try {
    const results = await getAlgoliaClient().search<any>([
      {
        indexName: PRODUCTS_INDEX_NAME,
        params: {
          filters: toAlgoliaFilter(
            {
              productIds: input.items.map((x) => x.productId),
            },
            new Date()
          ),
          userToken: input.userToken,
        },
      },
    ])
    return results.results[0].hits.map((x: AlgoliaProductVariant) =>
      toProduct(x)
    )
  } catch (e) {
    console.error("Error searching algolia recommendation items", e)
    return []
  }
}
